import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";
import colors from "@assets/colors";

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.blurBG,
    },
    v_modal: {
      width: 492,
      height: 320,
      borderRadius: 2,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.white,
    },
    t_title: {
      fontFamily: "DMSans-Bold", fontSize: 20, marginTop: 0,
      lineHeight: 28, textAlign: "center",
    },
    t_message: { fontFamily: "DMSans", fontSize: 16, marginTop: 25,
      lineHeight: 28, textAlign: "center",},
    t_message_bold: { fontFamily: "DMSans-Bold", },
    btn_cancel: { width: 200, height: 47, marginTop: 46, paddingHorizontal: 0,
      backgroundColor: colors.transparent, borderWidth: 1, borderColor: colors.colorPrimary, borderRadius: 6 },
    label_cancel: { fontSize: 15, fontFamily: "DMSans", color: colors.colorPrimary },
    btn_proceed: { width: 200, height: 47, marginTop: 46, 
      paddingHorizontal: 0, backgroundColor: colors.colorPrimary, borderRadius: 6 },
    label_proceed: { fontSize: 15, fontFamily: "DMSans" },
    divider: { width: 17 },
  },
  {
    [DEVICE_SIZES.LG]: {
    },

    [maxSize(DEVICE_SIZES.MD)]:  {
    },
  }
);

export default useStyles;
